export const ApiCadastroEndpoints = {
  // Register
  sendRepresentativeFinalStepEmail: '/api/register/representative-final-step',
  sendRepresentativeFirstStepEmail: '/api/register/representative-first-step',
  investorRepresentative: 'api/register/save-representative',
  registrationsInfo: '/api/register/registrations-info',
  distributorsInfo: '/api/distributors/funds-distributors',
  insertRegistrationHistory: '/api/register/registration-history',
  agent: '/api/register/agent',
  approveDisapprove: '/api/register/approve-disapprove',
  agentByInvite: '/api/register/agent-by-invite',
  agentById: '/api/register/agent-by-id',
  updateAgentStatus: '/api/register/update-agent-status',
  registerUpdate: '/api/register/cadastral-update',
  updateKeyOptions: '/api/register/update-key-options',
  registrationsPaged: '/api/register/registrations-paged',
  expirations: '/api/register/expire',
  registrationsSearchTerm: '/api/register/registrations-search-term',
  agentFullRegistration: '/api/register/agent-full-registration',
  csv: '/api/register/csv',
  saveFingerprint: '/api/register/save-fingerprint',
  removeRegister: '/api/register/delete-register',
  // Person
  registerPerson: '/api/person',
  personByFinancialStatement: '/api/person/financial-statement',
  personByAgent: '/api/person/person-by-agent',
  personScoreByAgent: '/api/person/score-by-agent',
  personDocument: '/api/person/document',
  personAddress: '/api/person/address',
  personBankData: '/api/person/bank-data',
  personContractData: '/api/person/contract-data',
  personBeneficiariesData: '/api/person/beneficiaries',
  personFiles: '/api/person/files',
  personDisableFile: '/api/person/files/disable',
  personProfession: '/api/person/profession',
  personAuthorizations: '/api/person/authorizations',
  personSuitabilityQuestions: '/api/person/suitability/questions',
  personSuitabilityScore: '/api/person/suitability/score',
  personSuitabilityQuestionTrack: '/api/person/suitability/questions-track',
  personConfirmRegistration: '/api/person/confirm-registration',
  approveResponsibleRegister: '/api/person/approve-responsible-register',
  reproveResponsibleRegister: '/api/person/reprove-responsible-register',
  approveRegisterAsResponsible: '/api/person/approve-register-as-responsible',
  personInvestorConfirmation: '/api/person/investor-confirmation',
  personSendNonConformityTerm: '/api/person/send-nonconformity-term',
  personSignNonConformityTerm: '/api/person/sign-nonconformity-term',
  personGenerateSuitabilityFile: '/api/person/suitability/file',
  // Domain
  domain: '/api/domain/',
  domainStates: '/api/domain/states',
  // Services
  services: '/api/services',
  // Invitation
  senderInvitation: '/api/invitation/send-invitation',
  latestInvitation: '/api/invitation/latest-invitations',
  sendTwoFactorAuthentication: '/api/multifactor/factor-authentication',
  checkTokenInvitation: '/api/multifactor/check-token',
  saveInvestorDocumentUpload: '/api/upload/save-investor-document',
  downloadInvestorDocumentUpload: '/api/download/investor-document/',
  deleteInvestorDocumentUpload: '/api/upload/delete-investor-document',
  disableInvestorDocumentUpload: '/api/upload/disable-investor-document',
  stockExchangeInvestorsUpload: '/api/upload/save-b3-document/',
  onbaseIntegration: '/api/integration/onbase',
  invitationById: '/api/invitation/invitation-by-id',
  returnReasons: '/api/return-reasons',
  removeInvitation: '/api/invitation/delete-invitation',
  // Company
  registerCompany: '/api/company',
  companyByAgent: '/api/company/company-by-agent',
  companyRepresentatives: '/api/company/representatives',
  companyFiles: '/api/company/files',
  companyDisableFile: '/api/company/files/disable',
  companyEconomicGroup: '/api/company/economic-group',
  companyAuthorizations: '/api/company/authorizations',
  companySuitabilityQuestions: '/api/company/suitability/questions',
  companySuitabilityScore: '/api/company/suitability/score',
  companySuitabilityQuestionTrack: '/api/company/suitability/questions-track',
  companyConfirmRegistration: '/api/company/confirm-registration',
  companyBankData: '/api/company/bank-data',
  companyPatrimonial: '/api/company/patrimonial-situation',
  companyGenerateInvestorLevelFile: '/api/company/generate-investor-level-pdf',
  updateCompanySuitabilityWaiver: '/api/company/updateDispensaSuitability',
  companyGenerateSuitabilityFile: '/api/company/suitability/file',
  companyContractData: '/api/company/contract-data',
  companyBeneficiariesData: '/api/company/beneficiaries',
  // Suitability
  suitabilityAdequacy: '/api/suitability/questions/adequacy',
  suitabilityCompatibility: '/api/suitability/questions/compatibility',
  suitabilityKnowledge: '/api/suitability/questions/knowledge',
  // Audit
  getAuditByAgent: '/api/audit',
  // Users
  getUsersByInvitation: '/api/users/user-by-invitation/',
  getUserByDocumentPortal: '/api/users/document/',
  getUserByEmailPortal: '/api/users/email/',
  userUpdateEmailByDocumentPortal: '/api/users/user-update-email',
  // Question
  question: '/api/suitability/questions',
  // Mixpanel
  track: '/api/mixpanel',
  // Distribuitors
  distributorsPaged: '/api/distributors/distributors-paged'
};
